var React = require('react');

function IcCart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.96914 9.38732L12.7559 1.8287C13.1533 1.38616 13.8467 1.38616 14.2441 1.8287L21.0309 9.38732M21.0309 9.38732H2.30187C1.64476 9.38732 1.1669 10.013 1.33489 10.6483C3.42128 18.5383 4.45545 23 5.96914 23C14.3642 23 12.6358 23 21.0309 23C22.6131 23 23.5734 17.7991 25.6231 10.6755C25.8081 10.0326 25.3279 9.38732 24.6589 9.38732H21.0309Z","stroke":"currentColor","strokeWidth":"1.5"}));
}

IcCart.defaultProps = {"width":"27","height":"24","viewBox":"0 0 27 24","fill":"none"};

module.exports = IcCart;

IcCart.default = IcCart;
